import React, { useState, useRef } from "react";
import { Grid, Button, makeStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import brandTheme from "brandTheme/Theme";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CircularProgress from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
import FileUpload from "components/FileUpload/FileUpload";
import Camera from "react-html5-camera-photo"; // Make sure this is installed
import "react-html5-camera-photo/build/css/index.css"; // Required for camera
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import { removeSpecialCharFileName } from "utils/Utils";
import { parseAndSetFlag } from "utils/Utils";

const useStyles = makeStyles(() => ({
    nextButton1: {
      backgroundColor: brandTheme.buttonColor,
      color: brandTheme.white,
      borderRadius: "10px",
      padding: "2px 15px",
      minWidth: "140px",
      "&:hover": {
        backgroundColor: brandTheme.buttonHoverColor,
      },
    },
    buttonRow: {
      display: "flex",
      gap: "10px",
      marginTop: "10px",
      marginLeft:"30%",
      minHeight:'45px',
      "@media (max-width:600px)": {
        marginLeft:"0px"
      },
    },
    previewImage: {
      marginTop: "10px",
      width: "200px",
      height: "200px",
      objectFit: "cover",
      borderRadius: "8px",
      border: "1px solid #ccc",
    },
    button2: {
        minWidth: "140px",
        height:"100%",
        marginTop:0,
        backgroundColor: brandTheme.button2Color,
        "&:hover": {
          backgroundColor: brandTheme.buttonHoverColor,
        },
      },
      container: {
        height:'100%'
      }
  }));

const AadharPhotoCapture = ({ selectedScheme, closeModal, classes, loanApplicationId, editable,handleSave,featureFlags }) => {
  const localClasses = useStyles();
  const navigate = useNavigate();

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);

  const [frontImage, setFrontImage] = useState("");
  const [backImage, setBackImage] = useState("");
  const [captureSide, setCaptureSide] = useState(""); // "front" or "back"
  const [showCamera, setShowCamera] = useState(false);

  const [documentImage1, setDocumentImage1] = useState("");
  const [documentImage2, setDocumentImage2] = useState("");

  const [formData1,setFormData1] = useState({});
  const [formData2,setFormData2] = useState({});
  const { authToken } = useSelector((state) => state.login.authData);
  const enabledAadharMaskedPhoto = parseAndSetFlag(featureFlags?.enabledAadharMaskedPhoto);
  const toastUpdate = (type, msg, open) => {
    setToastMessageType(type);
    setToastMessage(msg);
    setToast(open);
  };

  const handleTakePhoto = async (dataUri) => {
    const blob = await fetch(dataUri).then((res) => res.blob());
  
    if (captureSide === "front") {
      setFrontImage(dataUri);
      setDocumentImage1("");
      UploadCameraFile(blob, "documentImage1");
    } else if (captureSide === "back") {
      setBackImage(dataUri);
      setDocumentImage2("");
      UploadCameraFile(blob, "documentImage2");
    }
  
    setShowCamera(false);
  };
  
  const UploadFile = async (file, type) => {
    setShowCamera(false)
    const formData = new FormData();
     const fileName = removeSpecialCharFileName(file.name)
    formData.append("file", file, fileName);
  
    // Clear captured image if switching to file
    if (type === "documentImage1") {
      setFrontImage("");  // Clear camera image preview
    } else if (type === "documentImage2") {
      setBackImage("");
    }
  
    setCallInProgress(true);
    const path = await apiHandler({
      url: endpoint.FILE_UPLOAD,
      method: "POST",
      authToken,
      data: formData,
    });
    setCallInProgress(false);
  
    const uploadedPath = path.data;
    if (type === "documentImage1") {
      setFrontImage(uploadedPath.name);
      setFormData1({file:file , name : file.name});
    } else if (type === "documentImage2") {
      setBackImage(uploadedPath.name);
      setFormData2({file:file, name: file.name});
    }
  };

  const UploadCameraFile = async (blob, type) => {
    const formData = new FormData();
    const extension = blob.type === "image/png" ? "png" : "jpeg";
    formData.append("file", blob, `${type}.${extension}`);

    if (blob?.size > 100) {
      setCallInProgress(true);
      const path = await apiHandler({
        url: endpoint.FILE_UPLOAD,
        method: "POST",
        authToken,
        data: formData,
      });
      setCallInProgress(false);

      if (path?.data?.error || path?.data?.error_code) {
        toastUpdate("Error", path?.data?.error || path?.data?.user_description, true);
      } else {
        const uploadedPath = path.data;
        if (type === "documentImage1") {
          setFrontImage(uploadedPath.name);
          setFormData1({file:blob , name:`${type}.${extension}` });
        } else if (type === "documentImage2") {
          setBackImage(uploadedPath.name);
          setFormData2({file:blob , name:`${type}.${extension}` });
        }
      }
    } else {
      toastUpdate("Error", "Photo size is 0 byte. Kindly reclick the photo", true);
    }
  };

  const onClickCamera = (side) => {
    setCaptureSide(side);
    setShowCamera(true);
  };
  const handleMaskedphoto = async () => {
     if(enabledAadharMaskedPhoto){
      setCallInProgress(true);
      const formData = new FormData();
      if (frontImage) {
        formData.append("front", formData1?.file , formData1?.name);
      }
      if (backImage) {
        formData.append("back", formData2?.file , formData2?.name);
      }
      formData.append("caseId", loanApplicationId);
      const res = await apiHandler({
        url: endpoint.AADHAR_PHOTO_MASKED,
        method: "POST",
        authToken: authToken,
        data: formData,
      });
      setCallInProgress(true);
      if(res?.data?.error_code || res?.data?.error) {
        toastUpdate("Error", res?.data?.user_description || res?.data?.error, true);
        return;
      }else{
        const maskedImage = res?.data?.documents;
        handleCancelUser(maskedImage?.[0]?.maskedDocumentUrl , maskedImage?.[1]?.maskedDocumentUrl);
      }
    }else{
      handleCancelUser(frontImage,backImage);
    }
  }
  const handleCancelUser = async (front, back) => {
    const documentLinks = [
      front?.trim(),
      back?.trim(),
    ].filter(image => image);
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.ADMIN_DOCUMENT_UPDATELINKS,
        method: "POST",
        authToken: authToken,
        data: {
          loanApplicationId: loanApplicationId,
          documentPhotoLinks: documentLinks,
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code && res?.data?.error_code === 403) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else {
        handleSave(formData1 ,formData2);
    }
  };

  return (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <SubHeader label="Upload Aadhar Photo" button1="Save" button1click={handleMaskedphoto} disabled1={!frontImage && !backImage} button2="Cancel" button2click={closeModal}/>
        </Grid>

        {/* FRONT IMAGE */}
        <Grid item xs={12} md={6}>
          <h4>Front Image</h4>
          <div className={localClasses.buttonRow}>
          <FileUpload
            addButtonProps={{ color: brandTheme.buttonColor }}
            changeButtonProps={{ color: brandTheme.buttonColor }}
            removeButtonProps={{ color: "danger" }}
            supportedMimeType={["image/jpeg", "image/png", "image/bmp", "image/tiff"]}
            sendFile={(file) => UploadFile(file, "documentImage1")}
            noPreview
            buttonClass
            localClasses={localClasses}
            name="Upload"
          />
          <Button
            className={localClasses.nextButton1}
            onClick={() => onClickCamera("front")}
          >
            Camera
          </Button>
          </div>
          {frontImage && (
            <img src={frontImage} alt="Front Aadhar" className={localClasses.previewImage} />
          )}
        </Grid>

        {/* BACK IMAGE */}
        <Grid item xs={12} md={6}>
  <h4>Back Image</h4>

  <div className={localClasses.buttonRow}>
    <FileUpload
      addButtonProps={{ color: brandTheme.buttonColor }}
      changeButtonProps={{ color: brandTheme.buttonColor }}
      removeButtonProps={{ color: "danger" }}
      supportedMimeType={["image/jpeg", "image/png", "image/bmp", "image/tiff"]}
      sendFile={(file) => UploadFile(file, "documentImage2")}
      noPreview
      buttonClass
      localClasses={localClasses}
      name="Upload"
    />
    <Button
      className={localClasses.nextButton1}
      onClick={() => onClickCamera("back")}
    >
      Camera
    </Button>
  </div>

  {backImage && (
    <img src={backImage} alt="Back Aadhar" className={localClasses.previewImage} />
  )}
</Grid>

        {/* CAMERA VIEW */}
        {showCamera && (
          <Grid item xs={12}>
            <Camera
              onTakePhoto={(dataUri) => handleTakePhoto(dataUri)}
              onCameraError={(error) => toastUpdate("Error", error.message, true)}
              isMaxResolution={true}
              isFullscreen={false}
              sizeFactor={1}
              idealFacingMode="environment"
            />
          </Grid>
        )}
      </Grid>

      {callInProgress && <CircularProgress callInProgress={callInProgress} />}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </div>
  );
};

AadharPhotoCapture.propTypes = {
  selectedScheme: PropTypes.any,
  closeModal: PropTypes.func,
  classes: PropTypes.object,
  loanApplicationId: PropTypes.any,
  editable: PropTypes.bool,
};

export default AadharPhotoCapture;
